// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".-summary-row{font-weight:700;background-color:#eee!important}", ""]);
// Exports
module.exports = exports;
